// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsReplacementAnchorStyles } from "@pace/App/Components/ProductDetails/ProductDetailsReplacementAnchor";
import IconArrowDown from "@pace/XDL/Icons/IconArrowDown";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { createLinkIconStyles } from "@pace/XDL/Utilities";
import { css } from "styled-components";

productDetailsReplacementAnchorStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

productDetailsReplacementAnchorStyles.title = {
    variant: "h6",
    css: css`
        margin: 0;
    `,
};

productDetailsReplacementAnchorStyles.description = {
    size: 14,
    lineHeight: "22px",
};

// TODO: Ask the designer to provide arrow down icon.
productDetailsReplacementAnchorStyles.link = {
    ...createLinkIconStyles(IconArrowDown, {
        css: css`
            margin-top: 4px;
            justify-content: start;
        `,
    }),
};
productDetailsReplacementAnchorStyles.replacementProductContainer = {
    css: css`
        display: flex;
        justify-content: right;
    `,
};
productDetailsReplacementAnchorStyles.replacementLink = {
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
    },
};
